import axios from "axios";
import { api } from "~/router/apiConfig";

export function show(contractId) {
    return axios.post(
        api.path("contractSpendingTotal.show", {
            contractId: contractId
        })
    );
}

export function showByDate(contractId, date) {
    return axios.post(
        api.path("contractSpendingTotal.showByDate", {
            contractId: contractId,
            date: date
        })
    );
}
